import React from 'react';
import { Link } from 'react-router-dom';
import { site } from '../data/site';
import type { LegalDocument } from '../types/legal';
type LegalPageProps = {
  document: LegalDocument;
};
export function LegalPage({
  document
}: LegalPageProps) {
  return <article className="w-full bg-white" data-id="element-67" data-mp="94w8jq6fjqti">
      <header className="border-b border-navy-100 bg-brand-indigo/[0.035]" data-id="element-68" data-mp="47cuordn9g23">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20" data-id="element-69" data-mp="i7noa26c98qy">
          <nav aria-label="Breadcrumb" className="mb-6" data-id="element-70" data-mp="i643by9qm9iu">
            <Link to="/" className="text-sm font-medium text-brand-indigo hover:text-brand-violet" data-id="element-71" data-mp="e6lj74pqq2h2">
              ← Back to home
            </Link>
          </nav>
          <h1 className="text-3xl font-bold tracking-tight text-navy-800 sm:text-4xl" data-id="element-72" data-mp="my3zrgqlmkao">
            {document.title}
          </h1>
          <span aria-hidden="true" className="mt-4 block h-1 w-16 rounded-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-73" data-mp="11w64hu9d9bti" />
          <p className="mt-4 text-sm text-navy-400" data-id="element-74" data-mp="3osweokb2gibg">
            Last updated: {site.lastUpdated}
          </p>
          <p className="mt-6 text-base leading-relaxed text-navy-600" data-id="element-75" data-mp="3trhisutfvm56">
            {document.intro}
          </p>
        </div>
      </header>

      <div className="mx-auto max-w-3xl px-6 py-16" data-id="element-76" data-mp="6m8ffb2p6pdp">
        {document.sections.map(section => <section key={section.heading} className="mb-12 last:mb-0" data-id="element-77" data-mp="blclhsubs6zt">
            <h2 className="border-l-2 border-brand-violet/50 pl-4 text-lg font-semibold text-navy-800" data-id="element-78" data-mp="bl2x29oxi7w8">
              {section.heading}
            </h2>
            {section.paragraphs?.map(paragraph => <p key={paragraph} className="mt-4 text-base leading-relaxed text-navy-500" data-id="element-79" data-mp="ld8uhyxy9hit">
                {paragraph}
              </p>)}
            {section.bullets && <ul className="mt-4 space-y-2.5" data-id="element-80" data-mp="zae0y01ksiel">
                {section.bullets.map(bullet => <li key={bullet} className="flex gap-3 text-base leading-relaxed text-navy-500" data-id="element-81" data-mp="2vdiq1917qmlg">
                    <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brand-cyan" data-id="element-82" data-mp="2qcw4pxzku5bp" />
                    <span data-id="element-83" data-mp="30btz3hjoot2m">{bullet}</span>
                  </li>)}
              </ul>}
          </section>)}

        <div className="mt-14 overflow-hidden rounded-2xl border border-brand-indigo/20 bg-brand-indigo/[0.04]" data-id="element-84" data-mp="3a38424ueml35">
          <span aria-hidden="true" className="block h-1 w-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-85" data-mp="3o392ldn75gfg" />
          <div className="p-6" data-id="element-86" data-mp="3j1tmlzzvm03x">
            <h2 className="text-sm font-semibold text-navy-800" data-id="element-87" data-mp="1tnwsk7vvgje8">Questions?</h2>
            <p className="mt-2 text-sm leading-relaxed text-navy-500" data-id="element-88" data-mp="1opva9p69so3t">
              Contact our support team by email at{' '}
              <a href={`mailto:${site.supportEmail}`} className="font-medium text-brand-indigo hover:text-brand-violet" data-id="element-89" data-mp="47b32ejaj0z2">
                {site.supportEmail}
              </a>
              . {site.brandName} is operated by {site.legalEntity}.
            </p>
          </div>
        </div>
      </div>
    </article>;
}